export const FROM = {
  COMMON: 1,
  LAND: 2,
  RELATE_WORKSHEET: 3,
  CARD: 4,
  DRAFT: 21,
};

export const RELATION_TYPE_NAME = {
  1: _l('任务'),
  2: _l('项目'),
  3: _l('日程'),
  4: _l('文件'),
  5: _l('申请单'),
  6: '',
  7: _l('日程'),
};
